import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import AxiosInstance from '../Axios';
import { CListGroup, CListGroupItem, CButton } from '@coreui/react';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';

// Додавання сторінок до faq
const PageFaqs = (props) => {
   // console.log("props", props);
   // props.page_id - id-page

   // Сторінки, які додані до faq
   const [faqsItem, setFaqsItem] = useState([]);
   // Сторінки, які додані до faq, записані у форматі PUT (`api/faqs/id`) для відправлення
   const [oldFaqs, setOldFaqs] = useState([]);
   // Вибрана сторінка з пошуку
   const [selectedOption, setSelectedOption] = useState(null);
   // Текст для popup
   const popupTextPutSuccess = "Сторінку додано";
   const popupTextDeleteSuccess = "Сторінку видалено";
   const popupTextWarning = "Вибрана сторінка вже належить до даного faq";

   let i = 0;
   const handleChange = (selectedOption) => {
      setSelectedOption(selectedOption);
   };

   // Завантаження всіх FAQ для вибору з випадаючого списку
   const loadOptions = async (inputValue) => {
      return await AxiosInstance.get(`/faqs?name=${inputValue}`, { headers: { 'accept': 'application/json' } }).then((response) => {
         return response.data.map((result) => ({
            label: result.name,
            value: result.id,
         }));
      });
   };

   // Запит за категоріями, які вже додані до faq
   // const getParent = async () => {
   //    AxiosInstance.get(`/pages?faqs.id=${props.faq_id}`, { headers: { 'accept': 'application/json' } }).then((response) => {
   //       // console.log("response get faqs", response);
   //       setPagesItem(response.data)
   //    });
   // }

   //Запит на оновлення faq
   const getParent = async () => {
      AxiosInstance.get(`/faqs?pages.id=${props.page_id}`, { headers: { 'accept': 'application/json' } }).then((response) => {
         // console.log("response get faqs", response);
         setFaqsItem(response.data
            // ?.['hydra:member']
         )
      });
   }

   useEffect(() => {
      getParent();
   }, [props]);



   // Заповнити FAQ, які додані до сторінки, записані у форматі PUT (`api/fa/id`) для відправлення
   useEffect(() => {
      if (faqsItem?.length > 0) {
         let oldFaqs = [];
         // Наповнити масив з FAQ, перетвеними у формат для API
         faqsItem?.map(el => oldFaqs.push(`/api/faqs/${el.id}`));
         // console.log("oldFaqs", oldFaqs);
         setOldFaqs(oldFaqs);
      }
      else {
         setOldFaqs([]);
      }

   }, [faqsItem]);

   // Додати нову сторінку
   const handleSave = () => {
      // Перевірка, чи вибрана сторінка вже належить до даного faq
      let enters = faqsItem.length > 0 ? faqsItem.some(el => el.id === selectedOption.value) : false;
      if (enters) {
         // Popup про неуспішні зміни
         props.toastifyWarning(popupTextWarning);
      } else {
         // Вибрана нова сторінка
         let newFaqs = [`/api/faqs/${selectedOption.value}`];
         // Об'єднати старі категорії (якщо є) і нову категорію
         let faqs = oldFaqs.length > 0 ? oldFaqs.concat(newFaqs) : newFaqs;
         // console.log('pages', pages);
         // Дані, які підуть із запитом
         let article = {
            faqs: faqs
         };
         // console.log('article', article)

         // Оновити сторінки для faq
         AxiosInstance.put(`/pages/${props.page_id}`, article).then((response) => {
            // AxiosInstance.put(`/faqs/${props.faq_id}`, article, { headers: { 'accept': 'application/json' } }).then((response) => {
            // console.log("response put", response);
            if (response.status == 200) {
               // Popup про успішні зміни
               props.toastifySuccess(popupTextPutSuccess);
               getParent();
            }
         });
      };
   };

   // Видалити сторінку від faq
   const deleteFaq = (id) => {
      let faqs = [];
      // Відфільтрувати категорію, яку потрібно видалити
      let filterFaqs = faqsItem.filter(el => el.id !== id);
      // Наповнити масив з сторінками, перетвеними у формат для API
      filterFaqs.map(el => faqs.push(`/api/faqs/${el.id}`));
      // Дані, які підуть із запитом
      let article = {
         faqs: faqs
      };

      // console.log('article', article)

      // Оновити FAQ для page
      AxiosInstance.put(`/pages/${props.page_id}`, article).then((response) => {
         // console.log("response put", response);
         if (response.status == 200) {
            // Popup про успішні зміни
            props.toastifySuccess(popupTextDeleteSuccess);
            getParent();
         }
      });
   };

   // Видалити сторінку з faq
   function Deleted(row) {
      confirmAlert({
         title: 'Ви впевнені що хочите видалити цей пункт ?',
         message: 'Are you sure to do this.',
         buttons: [
            {
               label: 'Так',
               onClick: () => {
                  // console.log("delete row id", row);
                  deleteFaq(row);
               }
            },
            {
               label: 'Ні',
               onClick: () => {
                  return;
               }
            }
         ]
      });
   };
   // console.log('props', props)
   // console.log('faqsItem', faqsItem)
   // console.log('salectedOption', selectedOption)
   // console.log('oldFaqs', oldFaqs)

   return (
      <>
         <div className="row">
            <div className="col"><h3>FAQ</h3></div>
            <div className="col d-flex">
               <AsyncSelect
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  value={selectedOption}
                  onChange={handleChange}
                  className="flex-grow-1 me-2"
               />
               <CButton onClick={handleSave} className="mb-2" color="secondary">+</CButton>
            </div>
         </div>

         {/* Список з доданими FAQ */}
         {
            (faqsItem?.length > 0) ?
               <CListGroup className="mb-3">
                  {
                     faqsItem?.map((v, k) => {
                        i++;
                        return (
                           <CListGroupItem key={k} className="d-flex justify-content-between align-items-center">
                              <Link to={`/faq/update/${v.id}`} >{`${i})`} {v.name}</Link>
                              {/* {`${i})`} {v.name} */}
                              <CButton color="danger" variant="outline" onClick={() => { Deleted(v.id) }}>
                                 Видалити
                              </CButton>
                           </CListGroupItem>
                        )
                     })
                  }
               </CListGroup>
               :
               <p className="ml-3">FAQ не знайдено</p>
         }
      </>
   );
};

export default PageFaqs;